import { CreditCardBrandEnum } from 'enums'
import React from 'react'
import styled from 'styled-components'
import media from 'styles/media'

interface CreditCardDetailsProps {
  cardBrand: string
  cardholderName: string
  cardLastDigits: string
}

export default function CreditCardDetails({ cardBrand, cardholderName, cardLastDigits }: CreditCardDetailsProps) {
  return (
    <CardDetailsWrapper>
      <CardType src={getIconCreditCardByBrand(cardBrand)} alt="icon-brand-credit-card" />
      <Truncate>{cardholderName}</Truncate>***{cardLastDigits}
    </CardDetailsWrapper>
  )
}

function getIconCreditCardByBrand(brand: string) {
  switch (brand) {
    case CreditCardBrandEnum.Visa:
      return `${process.env.PUBLIC_URL}/assets/payment/visa.svg`
    case CreditCardBrandEnum.MasterCard:
      return `${process.env.PUBLIC_URL}/assets/payment/master-card.svg`
    case CreditCardBrandEnum.JCB:
      return `${process.env.PUBLIC_URL}/assets/payment/jcb.svg`
  }
}

const CardDetailsWrapper = styled.span`
  display: flex;
  align-items: center;

  @media (${media.screenSmMiniMax}) {
    font-size: 12px;
  }
`

const CardType = styled.img`
  margin-right: 10px;
  max-width: 30px;
`

const Truncate = styled.div`
  max-width: 6rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 8px;

  @media (${media.screenSmMiniMax}) {
    margin-right: 4px;
    max-width: 4rem;
  }

  @media (${media.screenXsMax}) {
    margin-right: 2px;
    max-width: 3rem;
  }
`
